import { PublicLayout } from "../../components/Layout/PublicLayout";
import { ProfileOrders } from "../../components/Profile/ProfileOrders/ProfileOrders";
const breadcrumbsData = [
  {
    label: "Inicio",
    path: "/",
  },
  {
    label: "Mis Compras",
    path: "/profile/orders",
  },
];
const OrdersProfile = () => {
  return (
    <PublicLayout breadcrumb={breadcrumbsData} breadcrumbTitle='Mis Compras'>
      <ProfileOrders />
    </PublicLayout>
  );
};

export default OrdersProfile;
